import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { API } from "../lib/catalogueApi";
import { openAssistant, visitorId } from "../lib/assistantApi";
import { ProductCard } from "./ProductCard";

// T71: a search is never blank. Rhyte AI (or the deterministic fallback) finds close, purchasable alternatives; cards are live data.
export function ZeroResults({ q }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    setD(null);
    fetch(`${API}/assistant/zero?q=${encodeURIComponent(q)}&visitor_id=${encodeURIComponent(visitorId())}`).then((r) => r.json()).then(setD).catch(() => setD({ items: [] }));
  }, [q]);
  return (
    <div className="mt-2 text-left" data-testid="zero-results" data-source={d?.source || ""}>
      <p className="font-bold text-[var(--brand-primary)]" data-testid="zero-results-message">
        No exact matches for &ldquo;{q}&rdquo;.{d?.items?.length ? (d.source === "ai" ? " Rhyte AI found these close alternatives." : " Here are some close alternatives.") : ""}
      </p>
      <button type="button" onClick={() => openAssistant({ page: "search", q, send: q })} data-testid="zero-ask-ai"
        className="ai-ring relative mt-3 inline-flex min-h-[44px] items-center gap-2 rounded-full bg-[var(--brand-primary)] px-5 text-sm font-bold text-white">
        <Sparkles size={16} aria-hidden="true" /> Ask Rhyte AI
      </button>
      {!d && <p className="mt-4 text-sm text-slate-500" data-testid="zero-results-loading">Looking for close alternatives…</p>}
      {!!d?.items?.length && (
        <div className="mt-5 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4" data-testid="zero-results-grid">
          {d.items.map((p) => <ProductCard key={p.id} p={p} />)}
        </div>
      )}
    </div>
  );
}

// T71: low-confidence search (most words matched nothing) - best results stay, with a clear note + Rhyte AI handoff
export function WeakMatch({ q }) {
  return (
    <div className="mb-4 flex flex-wrap items-center gap-3 rounded-xl border border-[var(--brand-primary)]/30 bg-[var(--brand-primary-tint)] p-3" data-testid="weak-match">
      <p className="flex-1 text-sm font-semibold text-[var(--brand-primary)]" data-testid="weak-match-message">Some of your words didn&rsquo;t match. Here are the closest results Rhyte AI found.</p>
      <button type="button" onClick={() => openAssistant({ page: "search", q, send: q })} data-testid="weak-match-ask-ai"
        className="ai-ring relative inline-flex min-h-[44px] items-center gap-2 rounded-full bg-[var(--brand-primary)] px-4 text-sm font-bold text-white">
        <Sparkles size={16} aria-hidden="true" /> Ask Rhyte AI
      </button>
    </div>
  );
}
